const flyoutToggles = document.querySelectorAll(".toggle-flyout");
const menuItemsHaveChildren = document.querySelectorAll(".menu-item-has-children");

// This is the important part!

function collapseSection(element) {

    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;
    
    // temporarily disable all css transitions
    var elementTransition = element.style.transition;
    var elementTransition = '';
    element.style.transition = '';
    
    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we 
    // aren't transitioning out of 'auto'
    requestAnimationFrame(function() {
      element.style.height = sectionHeight + 'px';
      element.style.transition = elementTransition;
      
      // on the next frame (as soon as the previous style change has taken effect),
      // have the element transition to height: 0
      requestAnimationFrame(function() {
        element.style.height = 0 + 'px';
      });

    // Hide element when animation ends
    element.addEventListener('transitionend', function(e) {
        element.style.display = 'none';
      }, {once: true});
    });
  }
  
  function expandSection(element) {
    element.style.display = 'block';
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;
    
    // have the element transition to the height of its inner content
    element.style.height = sectionHeight + 'px';
  
    // when the next css transition finishes (which should be the one we just triggered)
    element.addEventListener('transitionend', function(e) {
      // remove "height" from the element's inline styles, so it can return to its initial value
      element.style.height = 'auto';
    }, {once: true});
  }


export const FlyoutMenu = {
    bindListeners() {
        flyoutToggles.forEach(flyoutToggle =>  {
            flyoutToggle.addEventListener('click', this.handleClick);
        })
        menuItemsHaveChildren.forEach(menuItem => {
            menuItem.addEventListener('focusout', this.handleFocusOut);
        })
    },
    handleFocusOut(e) {
        // Don't close if focus is moving within the same menu
        if (e.relatedTarget && e.relatedTarget.closest('.flyout-menu')) {
            return;
        }
        // Get all open menus so that submenus are also closed on menu close.
        const openMenu = document.querySelectorAll('.menu-item-has-children.submenu-open');
    
        openMenu.forEach(openMenu => {
            // Do not close menu related to click to prevent double firing.
            if (e.relatedTarget && openMenu === e.relatedTarget.closest('.submenu-open')) {
                return
            }
            FlyoutMenu.closeSubMenu(openMenu);
        })
    },
    handleClick(e) {
        const menuItem = e.target.classList.contains('menu-item-has-children') ? e.target : e.target.closest('.menu-item-has-children');

        if (menuItem.classList.contains('submenu-open')) {
            FlyoutMenu.closeSubMenu(menuItem);
        } else {
            FlyoutMenu.openSubMenu(menuItem);
        }
        e.preventDefault();
    },
    closeSubMenu(menuItem) {
        //collapseSection(menuItem.querySelector('.flyout-menu'))
        menuItem.classList.remove('submenu-open');
        // Aria labels on toggle and toggle-flyout
        this.getAriaElements(menuItem.children);
        console.log("closeSubMenu firing");
    },
    openSubMenu(menuItem) {
        //expandSection(menuItem.querySelector('.flyout-menu'))
        menuItem.classList.add('submenu-open');
        this.getAriaElements(menuItem.children);
    },
    getAriaElements(liElements) {
        const ariaElements = [...liElements].filter(child => child.hasAttribute('aria-expanded'));
        this.setAriaExpanded(ariaElements);
    },
    setAriaExpanded(ariaElements) {
        ariaElements.forEach(ariaElement => {
            ariaElement.setAttribute('aria-expanded', ariaElement.getAttribute('aria-expanded') === 'false' ? 'true' : 'false');
        })
    }
}